import { auth } from '@/lib/firebase';
import api from '@/lib/api';

const RESET = 'RESET';

export const MUTATIONS = {
  RESET: 'RESET',
  UNSUBSCRIBER: 'UNSUBSCRIBER',
};

export const GETTERS = {
  UNSUBSCRIBER: 'UNSUBSCRIBER',
};

const getDefaultState = () => ({
  unsubscriber: null,
});

export const state = getDefaultState();

export const mutations = {
  [MUTATIONS.UNSUBSCRIBER](state, unsubscriber) {
    state.unsubscriber = unsubscriber;
  },

  [RESET](state) {
    Object.assign(state, getDefaultState());
  },
}

export const getters = {
  [GETTERS.UNSUBSCRIBER](state) {
    return state.unsubscriber;
  },
}

export const actions = {
  async fetchData(_, params) {
    try {
      const token = await auth.currentUser.getIdToken();
      const response = await api.get(
        '/habitat',
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async addService(_, payload) {
    try {
      const token = await auth.currentUser.getIdToken();
      const response = await api.post(
        '/habitat/services',
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async updateService(_, payload) {
    try {
      const token = await auth.currentUser.getIdToken();
      const response = await api.put(
        `/habitat/services/${payload.id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async deleteService(_, params) {
    try {
      const token = await auth.currentUser.getIdToken();
      const serviceId = params.serviceId;

      delete params.serviceId;

      const response = await api.delete(
        `/habitat/services/${serviceId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchServices(_, params) {
    try {
      const token = await auth.currentUser.getIdToken();
      const response = await api.get(
        '/habitat/services',
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async addAddress(_, { payload }) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.post(
        '/habitat/address',
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async fetchAddresses(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get(
        '/habitat/address',
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async fetchAddressNames(_, params) {
    try {
      const token = await auth.currentUser.getIdToken();
      const response = await api.get(
        '/habitat/addresses/names',
        {
          params,
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async deleteAddress(_, { id }) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.delete(
        `/habitat/address/${id}`,
        { 
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async getSegments() {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get('habitat/target/segments',
        { 
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async addCustomSegment(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.post(
        `/habitat/target/segments`,
        payload,
        { 
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async addTarget(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.post(
        `/habitat/target`,
        payload,
        { 
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async getTargets() {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get('habitat/target',
        { 
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async updateTarget(_, { id, payload }) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.put(`habitat/target/${id}`,
        payload,
        { 
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async deleteTarget(_, { id }) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.delete(`habitat/target/${id}`,
        { 
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async getSynergies(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get('habitat/my-tree',
        {
          params: payload,
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async addSynergyInMyTree(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.post('habitat/my-tree',
        payload,
        { 
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async fetchPartners(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get('habitat/partners', {
        params: payload,
        headers: { Authorization: `Bearer ${token}` }
      });
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async addPartners(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.post('habitat/partners',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async addPartnersByInvite(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.post('habitat/partners/invite',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async getEcosystem() {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get('habitat/my-ecosystem', {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async updatePartnerRequest(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.put('habitat/my-ecosystem/request',
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async getPartnersBySpec(_, {id, page, limit}) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get(`habitat/partners/${id}`,
        { 
          params: { page, limit },
          headers: { Authorization: `Bearer ${token}` } 
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async addMessage(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.post('habitat/messages',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async getMessages(_, { userId, partnerId }) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get(`habitat/messages/${userId}/${partnerId}`,
        { 
          headers: { Authorization: `Bearer ${token}` } 
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async addIndication(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.post('habitat/indication',
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async getIndicationsStats() {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get(`habitat/indication/stats`,
        { 
          headers: { Authorization: `Bearer ${token}` } 
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async getPartnersIndication() {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.get(`habitat/indication/partners`,
        { 
          headers: { Authorization: `Bearer ${token}` } 
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async updateIndicationStatus(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.put('habitat/indication/status',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async updateConverted(_, payload) {
    const token = await auth.currentUser.getIdToken();
  
    try {      
      const response = await api.put('habitat/indication/converted',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  reset({ commit, dispatch }) {
    dispatch('unsubscribeAll');
    commit(RESET);
  },

  unsubscribeAll({ getters, commit }) {
    const prevUnsubscriber = getters[GETTERS.UNSUBSCRIBER];
    
    if (prevUnsubscriber) {
      prevUnsubscriber();
      commit(MUTATIONS.UNSUBSCRIBER, null);
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
